module.exports = __webpack_public_path__ + "img/avatar7.09a7a6f3.png";